<template>
  <BodyCard id="create">
    <RoundButtonImage :image="productCopy.image" @change="changeImage" />
    <ImageComponent :image="productCopy.banner" @change="changeBanner" />
    <v-text-field
      class="headline mt-2"
      solo
      flat
      v-model="productCopy.name"
      :label="$t('Edit name')"
      prepend-inner-icon="mdi-pencil"
      autofocus
    ></v-text-field>

    <v-textarea
      class="subtitle-1"
      auto-grow
      row-height="33"
      flat
      solo
      rows="1"
      v-model="productCopy.description"
      :label="$t('Edit description')"
      prepend-inner-icon="mdi-pencil"
    ></v-textarea>
    <v-text-field
      class="headline mt-2"
      solo
      flat
      v-model="productCopy.price"
      :label="$t('Price')"
      type="number"
      suffix="€"
      step="0.01"
      min="0"
      prepend-inner-icon="mdi-pencil"
    ></v-text-field>

    <div class="mx-3">
      <v-checkbox v-model="productCopy.visibility" :label="$t('Visible')" />
      <v-autocomplete
        v-model="productCopy.category"
        item-value="id"
        :items="categories"
        item-text="name"
        :label="$t('Category')"
        flat
        clearable
      ></v-autocomplete>
      <Options :productOptions="productCopy.options" @updateOptions="updateOptions" />

      <Allergens
        v-if="false"
        :allergensSelected="productCopy.allergens"
        @updateAllergens="updateAllergens"
      />

      <v-row class="d-flex justify-end mr-1 mt-2">
        <v-btn v-if="saving" outlined color="primary" disabled>{{ $t("Saving") }}...</v-btn>

        <v-btn v-else outlined color="primary" @click="save">{{ $t("Save") }}</v-btn>
      </v-row>
    </div>
  </BodyCard>
</template>

<script>
import BodyCard from "@/views/dashboard/components/BodyCard";
import Allergens from "@/components/Allergens";
import Options from "@/components/Options";
import ImageComponent from "@/views/dashboard/components/ImageComponent";
import RoundButtonImage from "@/views/dashboard/components/RoundButtonImage";
import { storage } from "@/firebase/firestore.js";
export default {
  components: {
    Allergens,
    Options,
    BodyCard,
    ImageComponent,
    RoundButtonImage
  },
  props: ["product"],
  data() {
    return {
      productCopy: this.product.clone(),
      saving: false
    };
  },
  methods: {
    async save() {
      if (!this.productCopy.category) {
        this.productCopy.category = -2;
      }
      this.saving = true;
      this.$store.state.promiseLoading = true;
      let id = this.productCopy.id;
      if (!this.product.category) {
        console.log("cosas");
      }
      if (this.productCopy.id !== undefined) {
        id =
          "generated" +
          Math.random()
            .toString(36)
            .substring(2, 15) +
          Math.random()
            .toString(36)
            .substring(2, 15);
      }
      if (
        (this.productCopy.image != "") &
        (this.productCopy.image != this.product.image)
      ) {
        let image = await this.updateImage(
          this.$store.getters.restaurant.id + "/images/" + id + "image",
          this.productCopy.image.split(",")[1]
        );
        this.productCopy.image = image;
      }
      if (
        (this.productCopy.banner != "") &
        (this.productCopy.banner != this.product.banner)
      ) {
        let banner = await this.updateImage(
          this.$store.getters.restaurant.id + "/images/" + id + "banner",
          this.productCopy.banner.split(",")[1]
        );
        this.productCopy.banner = banner;
      }
      let savePromises = [];
      if (
        !this.productCopy.index ||
        this.productCopy.category !== this.product.category
      ) {
        this.productCopy.category =
          this.product.category && this.productCopy.category !== -1
            ? this.productCopy.category
            : -2;

        const updateCategoryProducts = categoryProducts => {
          // Save new product and correct old product indexes if they are wrong
          let index = 0;
          categoryProducts.forEach(product => {
            if (product.index !== index) {
              product.index = index;
              savePromises.push(product.save());
            }
            index++;
          });
        };

        // Update category products

        let oldCategory = this.product.category;

        let newCategoryMenu = this.$store.getters.menu.find(
          category => category.id === this.productCopy.category
        );
        let newCategoryProducts = newCategoryMenu
          ? newCategoryMenu.products
          : [];
        let productCopyId = this.productCopyId;
        newCategoryProducts.push(this.productCopy);
        updateCategoryProducts(newCategoryProducts);

        if (oldCategory && oldCategory !== this.productCopy.category) {
          let oldCategoryProducts = this.$store.getters.menu
            .find(category => category.id === oldCategory)
            .products.filter(product => product.id !== productCopyId);
          updateCategoryProducts(oldCategoryProducts);
        }
      }
      if (!savePromises.length) {
        savePromises = [this.productCopy.save()];
      }
      await Promise.all(savePromises);
      this.saving = false;
      this.$emit("closeDialog");
    },

    changeBanner(url) {
      this.productCopy.banner = url;
    },
    changeImage(url) {
      this.productCopy.image = url;
    },
    updateOptions(options) {
      this.productCopy.options = options;

      //   if (index >= 0) this.productCopy.options.splice(index, 1);
    },
    updateAllergens(allergens) {
      this.productCopy.allergens = allergens;

      //   if (index >= 0) this.productCopy.options.splice(index, 1);
    },
    async updateImage(name, file) {
      var imagesRef = storage.child(name);
      try {
        let snapshot = await imagesRef.putString(file, "base64");

        let downloadURL = await snapshot.ref.getDownloadURL();
        return downloadURL;
        // this.saving = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      } catch (error) {
        switch (error.code) {
          case "storage/unauthorized":
            // TODO Handle error
            // alert("unauthorized");
            break;
          case "storage/canceled":
            // alert("canceled");
            break;
          case "storage/unknown":
            // alert("unknown");
            break;
          default:
          // alert(error.code);
        }
      }
    }
  },
  watch: {
    product() {
      this.productCopy = this.product.clone();
    }
  },
  computed: {
    categories: function() {
      let categories = this.$store.getters.categories;

      return categories.sort(function(a, b) {
        return a.index - b.index;
      });
    }
  }
};
</script>
